import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private auth: AuthService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.auth.isLoggedIn) {

      if (next.url[0].path == 'weedfree' && this.auth.client != 1) {
        this.router.navigate(['/404'], { queryParams: { 'e': btoa(state.url.toString()) } });
        return false;
      }

      return true;
    }
    
    this.router.navigate(['/login'], { queryParams: { 'return': state.url.toString() } });
    return false;
  }
  
}
